import React from 'react';
import Logo from 'fitbeat.react-native-components/assets/images/logo-black.png';
import { EnabledFeatures } from 'fitbeat.models';
import {
  Avatar, Icon, Theme, UserDataConsumer, NutritionIconToggle,
} from 'fitbeat.react-native-components';
import { connect } from 'react-redux';
import { TitleTabBar } from './TitleTabBar';

const isMobile = window.innerWidth <= 550;

export const TitleBarAndMenu = connect((state, props) => ({
  ...props,
  title: state.ui.title,
  landingPageUrl: EnabledFeatures.getLandingPageUrl(state.auth.user.enabledFeatures),
}))(UserDataConsumer(class TitleBarAndMenu extends React.Component {
  componentDidMount() {
    $(document).foundation();
  }

  onShowInfoClick = () => {
    this.props.navigation.navigate('Help');
  };

  render() {
    const isOnNutrition = window.location.pathname === '/nutrition' || window.location.pathname === '/nutrition';
    const isOnHelp = window.location.pathname === '/help/Help';

    const { title, landingPageUrl } = this.props;
    return (
      <div className='menu-container'>
        <div className='title-bar'>
          <div className='' style={{ height: '50px', minWidth: '60px' }}>
            <div className='hide-for-small-only logo-container'>
              <a href={landingPageUrl} target='_blank' rel='noreferrer'>
                <img src={Theme.organisationIconUrl || Theme.organisationLogoUrl || Logo} />
              </a>
            </div>

            <div className='hide-for-small-only tab-bar-container'>
              <TitleTabBar navigation={this.props.navigation} />
            </div>

            {(isMobile && isOnHelp) && (
            <div
              className='align-middle back-arrow-container'
              onClick={() => this.props.navigation.navigate('Profile')}
            >
              <Icon
                size={30}
                color={Theme.GREY_DARK_MEDIUM}
                name='ios-arrow-back'
              />
            </div>
            )}
          </div>

          <div className='show-for-small-only title-container'>
            <span className='title'>{title}</span>
          </div>

          <div>
            {this.props.user
              && (
              <>
                {(!isMobile || !isOnHelp) && (
                <div className='info-container' onClick={this.onShowInfoClick}>
                  <Icon
                    size={25}
                    name='ios-help-circle-outline'
                    style={{ color: Theme.CHARCOAL }}
                  />
                </div>
                )}
                <div
                  className='notification-container'
                  onClick={() => this.props.navigation.navigate('Notifications')}
                >
                  <Icon
                    size={25}
                    color={Theme.CHARCOAL}
                    name='ios-notifications-outline'
                  />
                  {this.props.user.notifications.unread !== 0
                          && (
                          <div className='count-container'>
                            <span className='count' id='messageCount'>{this.props.user.notifications.unread}</span>
                          </div>
                          )}
                </div>
                <div
                  className='hide-for-small-only avatar-container'
                  onClick={() => this.props.navigation.navigate('Profile')}
                >
                  <Avatar
                    size={30}
                    customStyle={{
                      width: 30,
                      height: 30,
                      borderRadius: 30 / 2,
                    }}
                    avatarId={this.props.user.userProfile.uid}
                    iconColor={Theme.GREY_MEDIUM}
                  />
                  <span style={{ color: Theme.CHARCOAL }}>More</span>
                </div>
              </>
              )}
          </div>
        </div>
      </div>
    );
  }
}));
